module.exports = __webpack_public_path__ + "img/64a42686c7053bcaf5130c487b0c6e29.svg";